import { createIcon } from '@chakra-ui/icons'

const AudioIcon = createIcon({
  viewBox: '0 0 800 1000',
  path: (
    <g>
      <g>
        <path
          fill="#FFFFFF"
          d="M27.8,996C14.7,996,4,985.3,4,972.2V364h792v605.6c0,14.5-11.8,26.3-26.3,26.3H27.8V996z"
        />
        <path
          fill="#E9EBF1"
          d="M792,368v601.6c0,12.3-10,22.3-22.3,22.3H27.8C16.9,992,8,983.1,8,972.2V368H792 M800,360H0v612.2 c0,15.4,12.5,27.8,27.8,27.8h741.9c16.7,0,30.3-13.6,30.3-30.3V360L800,360z"
        />
      </g>
      <path
        fill="#2196F3"
        d="M800,369.5H0V30.1C0,13.5,13.5,0,30.1,0h540.1l125.5,111.8L800,204.4V369.5z"
      />
      <path
        opacity={0.5}
        fill="#FFFFFF"
        d="M570.3,0v153.8c0,27.9,22.6,50.5,50.5,50.5H800L570.3,0z"
      />
      <text
        transform="matrix(1 0 0 1 57.6989 245.0462)"
        fill="#FFFFFF"
        fontSize="150px"
      >
        AUDIO
      </text>
      <g>
        <path
          fill="#E9EBF1"
          d="M282,847.7h-14.1c-15.4,0-29-6.1-38.3-17.2c-9.3-11.1-13.1-26.2-10.4-41.6c5.3-30.2,33.2-53.9,63.5-53.9h35.4 V550.2c0.1-22.2,17.3-40.6,39.4-42.1l154.9-10.3c11.7-0.7,23.1,3.4,31.6,11.3c8.5,8,13.4,19.2,13.4,30.8l-0.1,202.3 c0,3.1-0.2,6.2-0.7,9.4c-5.3,30.2-33.2,53.8-63.5,53.8H479c-15.4,0-29-6.1-38.3-17.2c-9.3-11.1-13.1-26.2-10.4-41.6 c5.3-30.2,33.2-53.9,63.5-53.9h35.4v-68.4c0-3.9-1.6-7.6-4.5-10.3c-2.8-2.7-6.7-4-10.5-3.8l-154.9,10.3c-7.4,0.5-13.1,6.6-13.1,14 v149.6c0,1.3-0.2,2.5-0.5,3.6c-0.1,4.3-0.3,5.1-0.4,5.9C340.2,824,312.3,847.7,282,847.7L282,847.7z M282.8,763.2 c-16.5,0-32.9,14-35.8,30.6c-1.3,7.2,0.2,13.8,4.2,18.6c3.8,4.6,9.8,7.1,16.7,7.1H282c16.5,0,32.9-14,35.8-30.6 c0,0,0.2-4.1,0.3-25.7L282.8,763.2L282.8,763.2z M494,721c-16.5,0-32.9,14-35.8,30.6c-1.3,7.2,0.2,13.8,4.2,18.6 c3.8,4.6,9.8,7.1,16.7,7.1h14.1c16.5,0,32.9-14,35.8-30.6c0.3-1.6,0.3-3.1,0.3-4.6l0.1-21.1H494L494,721z M359.5,536.2 c-7.4,0.5-13.1,6.6-13.1,14v44.7c3.6-1.3,7.3-2.1,11.3-2.3l154.9-10.3c5.7-0.3,11.5,0.4,16.9,2.3v-44.7c0-3.9-1.6-7.6-4.5-10.3 c-2.8-2.7-6.7-4-10.5-3.8L359.5,536.2z"
        />
      </g>
    </g>
  ),
})

export default AudioIcon
